// React Imports
import { ReactElement, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Component Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TabsComponent from "../../components/tabs-component/tabs-component";
import Pending from "./components/pending/pending";
import Processing from "./components/processing/processing";
import Completed from "./components/completed/completed";

// Style Imports
import "./waiting-approvals.scss";
import { CREATE_BREADCRUMB } from "../../store/actions";

const WaitingApprovals: React.FC = (): ReactElement => {
  const location = useLocation();
  const user = useSelector((state: any) => state.user);
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get("tab") || "1"
  );

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Waiting for approvals",
            type: "link",
            link: "/customers/waiting-approvals",
          },
        ],
      },
    });
  }, []);

  const items: any = [
    {
      key: "1",
      label: `Pending`,
      children: <Pending />,
    },
    {
      key: "2",
      label: `Processing`,
      children: <Processing />,
    },
    {
      key: "3",
      label: `Completed`,
      children: <Completed />,
    },
  ];

  const getItems = (): any => {
    if (user?.kycReviewGroup === "C") {
      return items;
    } else {
      return items.filter((item: any) => item.key !== "2");
    }
  };

  const onTabChange = (activeKey: string): void => {
    setActiveTab(activeKey);
  };

  return (
    <div className="waiting-approvals-container flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <TabsComponent
        items={getItems()}
        activeTab={activeTab}
        onChange={onTabChange}
      />
    </div>
  );
};

export default WaitingApprovals;
